import React from "react";

import { Image } from "../../../components/Image";

import * as styles from "./blurbElement.module.less";

export function BlurbElement({ image, heading, subheadline, ...props }) {
    return (
        <div className={styles.blurbElement} {...props}>
            <Image image={image} loading="lazy" />
            <div className={styles.blurbTextContainer}>
                <strong>{heading}</strong>
                <p className={styles.blurbSubheadline}>{subheadline}</p>
            </div>
        </div>
    );
}
